<template>  
  <div>   
    <q-collapsible :label="$t('global.MainMenu')" :opened="true" >
      <div>
        <q-item to="#" @click.native="openDialog('SideDialogWork')">
          <q-item-side icon="query_builder" />
          <q-item-main :label="$t('global.WorkTracking')" />
        </q-item>
        <q-item to="/assign" exact>
          <q-item-side icon="build" />
          <q-item-main :label="$t('global.DistributeOrders')" />
        </q-item>
        <q-item to="/definework" exact>
          <q-item-side icon="fitness_center" />
          <q-item-main :label="$t('global.DefineWork')" />
        </q-item>
        <q-item to="#" @click.native="openDialog('SideDialogEvent')">
          <q-item-side icon="add_a_photo" />
          <q-item-main :label="$t('global.CaptureEvent')" />
        </q-item>
        <q-item to="/enteryield" exact>
          <q-item-side icon="shopping_basket" />
          <q-item-main :label="$t('global.EnterYield')" />
        </q-item>
        <q-item to="/yieldJournal" exact>
          <q-item-side icon="shopping_basket" />
          <q-item-main :label="$t('global.YieldJournal')" />
        </q-item>
        <q-item to="/" exact>
          <q-item-side icon="home" />
          <q-item-main :label="$t('global.Journal')" />
        </q-item>
        <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" to="/worksummary" exact>
          <q-item-side icon="assignment_turned_in" />
          <q-item-main :label="$t('global.WorkSummary')" />
        </q-item>
        <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" to="/eventsummary" exact>
          <q-item-side icon="photo_camera" />
          <q-item-main :label="$t('global.EventSummary')" />
        </q-item>
      </div>
    </q-collapsible>
    
    <q-collapsible class="other" :label="$t('global.SatelliteMap')" :opened="true">
      <div>
        <q-item to="/map" exact>
          <q-item-side icon="business" />
          <q-item-main :label="$t('global.GeoRegions')" />    
          <q-btn
            color="primary"
            round
            size="sm"
            icon="help_outline"
            @click="showVideo"           
          />
        </q-item>
        <SelectGeoRegionTree></SelectGeoRegionTree>
        <q-item to="#" v-if="hasMap" @click.native="saveMap()">
          <q-item-side icon="save" />
          <q-item-main :label="$t('global.MapSave')" />
        </q-item>
      <q-item to="#" v-if="hasMap" @click.native="changeMap()">
        <q-item-side icon="satellite" />
        <q-item-main :label="mapLabel" />
      </q-item>  
      </div>
    </q-collapsible>

    <q-collapsible v-if="$store.state.session && $store.state.session.AccessLevel <= 20" :label="$t('global.ReportsAnalytics')" :opened="true">
      <div>
        <q-item to="/excelgeowork"> 
          <q-item-side icon="assessment" />
          <q-item-main label="Leistungsnachweis" />
        </q-item> 
        <q-item to="/excelanalyse"> 
          <q-item-side icon="assessment" />
          <q-item-main :label="$t('global.ExcelAnalytics')" />
        </q-item> 
         <q-item to="/rep_worktime/9">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.EmployeeJournal')" />
        </q-item> 
        <q-item to="/rep_worktime/1">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkJournal')" />
        </q-item> 
        <q-item to="/rep_worktime/11">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.OrderJournal')" />
        </q-item>  
        <q-item to="/rep_worktime/2">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkJournalMatrix')" />
        </q-item>
        <q-item to="/rep_worktime/3">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkJournalDrill')" />
        </q-item>
        <q-item to="/rep_worktime/4">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkJournalProduct')" />
        </q-item>
        <q-item to="/rep_worktime/5">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkJournalRegion')" />
        </q-item>
        <q-item to="/rep_worktime/6">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.ResourceTemplateList')" />
        </q-item>
        <q-item to="/rep_worktime/7">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.WorkReport')" />
        </q-item>
        <q-item to="/rep_worktime/8">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.ResourceReport')" />
        </q-item>
        <q-item to="/cost_bill/10">
          <q-item-side icon="list" />
          <q-item-main :label="$t('global.CostBill')" />
        </q-item>
      </div>
    </q-collapsible>

    <q-collapsible :label="$t('global.Administration')" :opened="true">
      <q-item @click.native="changeLocal()">
        <q-item-side icon="language" />
        <q-item-main :label="$t('global.ChangeLanguage')" />
      </q-item>
      <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" to="/user" exact>
          <q-item-side icon="accessibility_new" />
          <q-item-main :label="$t('global.ManageEmployees')" />
      </q-item>
      <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" @click.native="productEdit()" exact>
          <q-item-side icon="local_bar" />
          <q-item-main :label="$t('global.ManageProducts')" />
      </q-item>
      <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" @click.native="eventTypeEdit()" exact>
          <q-item-side icon="extension" />
          <q-item-main :label="$t('global.ManageEventTypes')" />
      </q-item>
      <q-item v-if="$store.state.session && $store.state.session.AccessLevel <= 20" @click.native="resourceEdit()" exact>
          <q-item-side icon="gavel" />
          <q-item-main label="Resourcen Verwalten" />
      </q-item>
      <q-item to="#" @click.native="changePassword()">
        <q-item-side icon="security" />
        <q-item-main :label="$t('global.ChangePassword')" />
      </q-item> 
    </q-collapsible>
    <q-item to="#" @click.native="logout()">
      <q-item-side icon="exit_to_app" />
      <q-item-main :label="$t('global.Logout')" />
    </q-item>
  </div>
</template>

<script>
import { openURL } from 'quasar'
import {eventBus} from '../main'
import store from '../store'
import SelectGeoRegionTree from './SelectGeoRegionTree'

export default {
  name: 'SelectEvent',
  components: {
    SelectGeoRegionTree,
    
  },
  data () {
    return {
      hasMap: null,
      selectedType: 'satellite',
      mapLabel: this.$t("global.MapRoad"),
    }
  },
  methods: {
    openURL,
    openDialog(dialog){
      if(store.state.session){  
        eventBus.$emit('loadDialog', dialog)
      }
      else{
        this.$router.push({name: 'Login'});
        this.$q.notify('Bitte einloggen.')
      } 
    },
    saveMap(){
      eventBus.$emit('saveMapSettings', null)
    }, 
    logout(){
      this.$store.state.session = null
      this.$router.push({name: 'Login'})
      this.$router.go()

    },
    changeMap(){
      if(this.selectedType == 'satellite'){
          this.selectedType = 'roadmap'
          this.mapLabel = this.$t("global.MapSatellite")
      }  
      else{
        this.selectedType = 'satellite'
        this.mapLabel = this.$t("global.MapRoad")
      }       
      eventBus.$emit('changeMapType', this.selectedType)
    },
    changePassword(){    
      if(store.state.session){  
        eventBus.$emit('loadDialog', 'SideDialogPassword')
      }
      else{
        this.$router.push({name: 'Login'});
        this.$q.notify('Bitte einloggen.')
      } 
    },
    productEdit(){
      eventBus.$emit('ProductEdit', { entity: 'Product', id: null })
    }, 
    eventTypeEdit(){
      eventBus.$emit('EntityEdit', { entity: 'EventType', id: null })
    }, 
    resourceEdit(){
        eventBus.$emit('EntityEdit', { entity: 'ResourceTemplate', id: null })
    },
    changeLocal () {
      var lang = 'en'
      var dateTimeFormat = 'DD.MM.YYYY HH:mm'

      if (this.$i18n.locale === 'de') {
        lang = 'fr'
      } 
      if (this.$i18n.locale === 'fr') {
        lang = 'it' 
      }
      if (this.$i18n.locale === 'it') {
        lang = 'es' 
      }
      if (this.$i18n.locale === 'sp') {
        lang = 'en' 
        dateTimeFormat = 'MM/DD/YYYY HH:mm'  
      }

      //Set language for our own translations:
      this.$i18n.locale = lang
      eventBus.$emit('Bus_ChangeLocale', lang)
      //Set language for Quasar
      if(lang == 'en'){
        lang = 'en-us'
      }
      import(`quasar-framework/i18n/${lang}`).then(lang => {
        this.$q.i18n.set(lang.default)
      })

      if(this.$store.state.session != null){
        this.$store.state.session.DateTimeFormat = dateTimeFormat
      }
      
    },
    showVideo(){
      window.open("https://video.insafety.ch/WTrackingGeofences2.mp4")
    }

  },
  created () {
    eventBus.$on('loadGeoRegion', (data) => {
      this.hasMap = true
    })
  }
  
}
</script>

<style scoped>
.other{
   background-color:ghostwhite
 }
</style>
